import { useState, useCallback } from 'react';

export function useLoading(initial = false) {
  const [loading, setLoading] = useState(initial);

  const runWithLoading = useCallback(
    async <T,>(fn: () => Promise<T>, minimumDuration?: number): Promise<T> => {
      setLoading(true);
      const startTime = Date.now();

      try {
        const result = await fn();

        if (minimumDuration) {
          const elapsed = Date.now() - startTime;
          const remaining = Math.max(0, minimumDuration - elapsed);
          if (remaining > 0) {
            await new Promise(resolve => setTimeout(resolve, remaining));
          }
        }

        return result;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { loading, runWithLoading, setLoading };

}

